const certificateList = [
  { cert_name: "Aquaculture Stewardship Council" },
  { cert_name: "B-Corp" },
  { cert_name: "Carbon Trust – Carbon Footprint labelling" },
  { cert_name: "Cradle to Cradle Certified™" },
  { cert_name: "Crossed Grain" },
  { cert_name: "Demeter" },
  { cert_name: "Ecocert – Cosmos Organic" },
  { cert_name: "EKOenergy" },
  { cert_name: "Fairtrade" },
  { cert_name: "Forest Stewardship Council" },
  { cert_name: "Global Organic Textile Standard" },
  { cert_name: "Green Key" },
  { cert_name: "LEED" },
  { cert_name: "MSC" },
  { cert_name: "PEFC" },
  { cert_name: "Rainforest Alliance" },
  { cert_name: "Roundtable on Sustainable Palm Oil" },
  { cert_name: "STANDARD 100 by OEKO-TEX®" },
];

export default certificateList;
